import { RouterProvider } from 'react-router-dom'
import Routing from './Routes'
import LogoutOverlay from './components/Spinners/LogoutOverlay'
import { useAuthProvider } from './modules/Auth/providers/AuthSupabaseProvider/AuthProvider.hook'

function App() {
  const { signingOut } = useAuthProvider()

  return (
    <>
      <RouterProvider router={Routing} />
      {signingOut ? <LogoutOverlay /> : null}
    </>
  )
}

export default App
